import * as React from 'react'
import * as ReactDOM from 'react-dom'

// Import bootstrap, animate.css and other styling
import './index.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'font-awesome/css/font-awesome.min.css'
import 'animate.css/animate.min.css'

import App from './App'

const root = document.getElementById('root')

ReactDOM.render(<App />, root)
